module.exports = __webpack_public_path__ + "img/pay-logo-union-wa.c0eb002e.png";